module.exports = __webpack_public_path__ + "static/media/hushdream-3.49839625.jpg";